<template>
  <div>
    <flat-pickr-base
      v-if="!isMobile"
      v-model="fpModelValue"
      :extended-input-emit="true"
      :show-clear-button="true"
      :month-count="2"
      :max-duration="28"
      @on-ready="fpInputValue = $event"
    />
    <div
      v-if="isMobile"
      class="form-group"
    >
      <label
        class="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <span
            class="input-group-text flatpickr-ignore"
          >
            <i class="icon"><icon-calender /></i>
          </span>

        </div>
        <button
          class="form-control-reset"
          type="button"
          data-ident="resetDate"
          :aria-label="$t('common:ariaLabel.dateResetButton')"
          @click="resetDate"
        >
          <i class="icon"><icon-times /></i>
        </button>
        <input
          type="text"
          :placeholder="$t('flatpickr:pickerInputAlternate.full')"
          autocomplete="off"
          :value="mobileDateInput"
          class="form-control flatpickr-placeholder flatpickr-input"
          readonly="readonly"
          data-ident="openPickerOnInput"
          @click="openModal($modal)"
        >
      </label>
    </div>
    <portal to="header-search-picker-modal">
      <search-picker-modal
        v-if="modalReady"
        :only-fill-store="onlyFillStore"
        @modal-initialized="initModal($modal)"
        @flatpickr-search-input-change="mobileDateInput = $event"
      />
    </portal>
  </div>
</template>

<script>
import SearchPickerModal from 'components/SearchPickerModal.vue';
import FlatPickrBase from 'components/FlatPickrBase.vue';

import FlatpickrSearchFunctions from 'mixins/FlatpickrSearchFunctions';
import DeviceHelper from 'mixins/DeviceHelper';
import { modalLogic } from 'mixins/composition/PickerModal';

import IconCalender from 'ICON:IconCalender';
import IconTimes from 'ICON:IconTimes';

/*

@@author        j0Shi
@@date          2019.11.12
@@desc          picker logic and component for the header search
@@usedby        Search -> HeaderSearch
                Home -> HeaderSearch

*/
export default {
  name: 'HeaderSearchMobilePicker',
  components: {
    IconCalender,
    IconTimes,
    SearchPickerModal,
    FlatPickrBase,
  },
  mixins: [FlatpickrSearchFunctions, DeviceHelper],
  props: {
    // indicates that the picker should only fill the store and not trigger search, required since headersearch is included on multiple pages with different behavior
    onlyFillStore: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { modalReady, openModal, initModal } = modalLogic();

    return { modalReady, openModal, initModal };
  },
  data() {
    return {
      // holding the current value for the mobile flatpickr input
      mobileDateInput: '',
      // mounted marker
      componentMounted: false,
    };
  },
  computed: {
    // checks mobile screen to switch between mobile and desktop picker
    isMobile() {
      if (!this.componentMounted) return false;
      return ['xs', 'sm', 'md'].includes(this.dh_breakpoint);
    },
  },
  mounted() {
    this.componentMounted = true;
  },
  methods: {
    // resets date (for example when clicking on the reset button in date input)
    resetDate() {
      if (this.onlyFillStore === true) {
        this.setSearchFilter({
          startDate: '',
          endDate: '',
        });
      } else {
        this.search({
          router: this.$router,
          filters: {
            startDate: '',
            endDate: '',
          },
        });
      }
      this.mobileDateInput = '';
    },
  },
};
</script>
